module.exports = __webpack_public_path__ + "img/滦南制锹.263cf994.jpg";